import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textMObj } = typographyStyles;

export const rootCss = {
  ...textMObj,
  display: "flex",
  backgroundColor: colors.brand.bisque[50],
  color: colors.ui.neutral[500],
  padding: "16px",
  width: "100%",
};

export const textCss = {
  margin: 0,
  lineHeight: "24px",
};

export const iconCss = {
  margin: "2px 8px 0 0",
  width: "100%",
  maxWidth: "18px",
  height: "100%",
  maxHeight: "18px",

  circle: {
    stroke: colors.ui.neutral[500],
  },

  path: {
    stroke: colors.ui.neutral[500],
  },
};
